import React from "react";

const TextsContext = React.createContext();

export default TextsContext;